import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const VoicePage = () => {
  useEffect(() => {
    document.title = 'お客様の声｜さかなの木';
  }, []);

  const reviews = [
    {
      text: '新鮮な魚が本当に美味しい！小皿スタイルなので色々な料理を楽しめるのが嬉しいです。日本酒の種類も豊富で、料理に合わせて選ぶのが楽しみです。',
      rating: 5,
      author: 'T.S様',
      date: '2024年1月',
    },
    {
      text: '駅から近くてアクセス抜群。店内も木目調で落ち着いた雰囲気です。一人でも入りやすく、カウンターで気軽に飲めるのがいいですね。',
      rating: 5,
      author: 'M.K様',
      date: '2024年1月',
    },
    {
      text: 'ランチの海鮮丼が絶品！新鮮なネタがたっぷりで、この価格は驚きです。〆の胡麻茶漬けも最高でした。また来ます！',
      rating: 5,
      author: 'Y.H様',
      date: '2023年12月',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="hero-section relative h-[60vh] md:h-[70vh] mt-20">
        <div className="hero-inner relative w-full h-full">
          <img
            className="hero-image absolute inset-0 w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/998cc9fdfc3e94f9198a40d52a19a6bf.webp"
            alt="お客様の声"
          />
          <div className="hero-overlay absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="hero-copy absolute inset-0 flex items-center justify-center text-center text-white px-4">
            <div>
              <h2 className="text-4xl md:text-6xl font-bold text-white">VOICE</h2>
              <p className="text-lg md:text-xl mt-4 text-white">お客様の声</p>
            </div>
          </div>
        </div>
      </section>
      <h1 className="text-center py-1 text-gray-500" style={{ fontSize: '10px', lineHeight: '1.2' }}>お客様の声｜鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木</h1>

      {/* Google Reviews Section */}
      <section 
        className="py-20 relative bg-cover bg-center"
        style={{ 
          backgroundImage: 'url(https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/3549e021c7d0857c12c4526d056c0a7f.png)'
        }}
      >
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <span className="text-primary text-sm font-bold tracking-wider">GOOGLE REVIEWS</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-6" style={{ color: '#3A3D3F' }}>
              Googleでの評価
            </h2>
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-3xl text-yellow-400"></i>
                ))}
              </div>
              <span className="text-2xl font-bold" style={{ color: '#3A3D3F' }}>4.7</span>
            </div>
            <p className="text-gray-600">多くのお客様から高評価をいただいております</p>
          </div>

          {/* Google Map Embed */}
          <div className="max-w-5xl mx-auto mb-12">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.8447890234567!2d139.6786174!3d35.5754191!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185f8c78e8258d%3A0xc7aca39b96b08092!2z44GV44GL44Gq44Gu5pyo!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="さかなの木 Googleマップ"
              ></iframe>
            </div>
          </div>

          <div className="text-center">
            <a
              href="https://www.google.co.jp/maps/place/%E3%81%95%E3%81%8B%E3%81%AA%E3%81%AE%E6%9C%A8/@35.5754191,139.6786174,17z/data=!3m1!5s0x60185ff9d8d165c1:0xc93e6502afad548d!4m8!3m7!1s0x60185f8c78e8258d:0xc7aca39b96b08092!8m2!3d35.5754148!4d139.6811923!9m1!1b1!16s%2Fg%2F11v5_x63jl?hl=ja&entry=ttu"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3 border-2 border-primary text-primary rounded-full font-medium hover:bg-primary hover:text-white transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-google-fill"></i>
              <span>Googleで口コミを見る</span>
            </a>
          </div>
        </div>
      </section>

      {/* Customer Reviews Section */}
      <section className="py-20" style={{ backgroundColor: '#d4edeb' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold inline-block relative" style={{ color: '#3A3D3F' }}>
              お客様の声
              <span className="absolute bottom-0 left-0 w-full h-1 bg-primary/30"></span>
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {reviews.map((review, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-8 shadow-md relative"
                style={{ transform: `translateY(${index % 2 === 0 ? '0' : '20px'})` }}
              >
                <div className="absolute -top-4 left-8">
                  <i className="ri-double-quotes-l text-5xl text-primary/20"></i>
                </div>
                <div className="flex gap-1 mb-4 justify-center">
                  {[...Array(review.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xl text-yellow-400"></i>
                  ))}
                </div>
                <p className="leading-relaxed text-center mb-6 italic" style={{ color: '#3A3D3F' }}>
                  {review.text}
                </p>
                <div className="text-center pt-4 border-t border-gray-200">
                  <p className="text-sm font-medium" style={{ color: '#3A3D3F' }}>{review.author}</p>
                  <p className="text-xs text-gray-500 mt-1">{review.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 relative">
        <div 
          className="absolute inset-0 w-full h-full"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/7bbe1f79eff63f7c9316e8fe173d22a0.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 drop-shadow-lg" style={{ color: '#3A3D3F' }}>
            あなたのご来店をお待ちしております
          </h2>
          <p className="text-lg mb-8 drop-shadow-md" style={{ color: '#3A3D3F' }}>
            新鮮な魚介と温かいおもてなしで、皆様をお迎えいたします
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:03-6715-0369"
              className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-[#B9A176] to-[#D4C4A0] text-white rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
              style={{ boxShadow: '0 8px 20px rgba(185, 161, 118, 0.4)' }}
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>電話予約</span>
            </a>
            <a
              href="https://page.line.me/278ynzvw?oat_content=url&openQrModal=true"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-gradient-to-r from-[#06C755] to-[#05B04D] text-white rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
              style={{ boxShadow: '0 8px 20px rgba(6, 199, 85, 0.4)' }}
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>LINE予約</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VoicePage;
